<template>
    <div >
      <RequiredText />
      <Input
          :name="`${id}-name`"
          :label="$t('crm.label.label')"
          :placeholder="$t('crm.label.label')"
          v-model="formData.title"
      />
    </div>
</template>

<script setup>
import { computed, ref, defineProps, onMounted } from "vue";
import Input from "@/components/Input.vue";
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText";


const store = useStore()
const props = defineProps({
  form: {
    type: Object,
    default: {
      title: null,
      note: '',
    }
  },
  id: {
    type: String,
    required: true
  }
})

const formData = ref(props.form)


</script>

<style scoped>

</style>
